<template lang="pug">
page-template(:title="title")
  v-sheet.mx-auto
    template(v-if="loading")
      v-skeleton-loader.mb-4(type="paragraph")
      v-skeleton-loader.mb-4(type="header")
      v-skeleton-loader.mb-4(type="chip")
        v-skeleton-loader.mb-4(type="paragraph")
        v-skeleton-loader.mb-4(type="paragraph")
    template(v-else-if="!sm")
      v-row
        v-col(cols=12, md=9)
          slot(name="header")
          .mt-2
            slot(name="main")
        v-col(cols=12, md=3)
          slot(name="side")
      v-divider.my-4
      slot(name="bottom")
      slot(name="after")
    template(v-else)
      slot(name="header")
      .mt-2
        slot(name="main")
      v-divider.my-4
      slot(name="bottom")
      slot(name="side")
      slot(name="after")
</template>

<script>
import PageTemplate from "./Page";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    get: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    PageTemplate,
  },
};
</script>
